/* eslint-disable */
import React, { useState, useEffect } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import { safeId, getArgByPath } from '~/config/data-cover';
import { ensureSlashEnd } from '~/utils/string/ensureSlashEnd';
import { DataLayer } from '~/components/DataLayer';
import { Link } from 'react-router-dom';
import css from './Comparativo.scss';


const classes = {
	root: css.comparativo,
	header: css.comparativoHeader,
	title: css.comparativoTitle,
	versions: css.comparativoVersions,
	avatar: css.comparativoAvatar,
	select: css.comparativoSelect,
	info: css.comparativoInfo,
	headerInfo: css.comparativoHeaderInfo,
	carro1avatar: css.comparativoCarro1Avatar,
	carro2avatar: css.comparativoCarro2Avatar,
	carro1: css.comparativoCarro1,
	carro2: css.comparativoCarro2,
	btn: css.comparativoBtn,
	button: css.comparativoButton,
};

const propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			id: PropTypes.string,
		}),
	}),
};

const defaultProps = {
	className: '',
	classes,
};

const extractIndexFromUrl = (pathname) => {
	const pathArray = ensureSlashEnd(pathname, false).split('/');
	return pathArray.length > 2 ? pathArray.pop() : 0;
};

export const Comparativo = ({ className, classes, location, match, ...props }) => {
	const state = location.state || getArgByPath(match.path);
	const idUrl = extractIndexFromUrl(location.pathname);
	const id = safeId(match.params.id || idUrl, 0, state.modal.length - 1);
	const [currentIndex, setCurrentIndex] = useState(id);
	const [optionOne, setOptionOne] = useState('volcano');
	const [optionTwo, setOptionTwo] = useState('volcano');
	//const caption = state.modal[currentIndex].caption;

	/*const putIdOnPath = (pathname, index) => {
		const pathArray = ensureSlashEnd(pathname, false).split('/');
		pathArray.length > 2 && pathArray.pop();
		const nupath = `${pathArray.join('/')}/${index}`;
		window.history.replaceState(null, state.modal[index].title, nupath);
	};*/

	const onChangeV1 = (evt) => {
		DataLayer.push('VersionsPage_SelecionouVeiculo1', evt.currentTarget.target);
	};
	console.log(onChangeV1)
	const onChangeV2 = (evt) => {
		DataLayer.push('VersionsPage_SelecionouVeiculo2', evt.currentTarget.target);
	};
	console.log(onChangeV2)
	useEffect(() => {
		/*return () => {
			DataLayer.push('Modal_Fechou_WithTitle', state.title);
		};*/
	}, []);

	// useEffect(() => {
	// 	console.log('OPTION ONE :: ', optionOne);
	// });

	const renderResume = (option) => {
		return (
			<ul>
				{option == 'volcano' && 
					<div style={{ overflow: "scroll", maxHeight: "32vh" }}>
						<li style={{ fontWeight: "bold" }}>Cantidad de lugares y puertas</li>
						<li>5 plazas y 4 puertas</li>

						<li style={{ fontWeight: "bold" }}>Airbag lateral</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Alarma</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Aire-acondicionado</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Asistente al arranque en pendiente</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Tapizado</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Cuero y tela</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Capota marítima</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Central multimedia de 7’’</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Control de estabilidad</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Asistencia a la dirección</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Asistencia a la dirección </li>
						<li>Eléctrica</li>

						<li style={{ fontWeight: "bold" }}>E-Locker - Control de tracción avanzado (TC+)</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Luces LED</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Antinieblas delanteros</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Protección luneta trasera</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Iluminación en la caja de carga</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Anclajes Isofix</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Motor</li>
						<li>Firefly 1.3 de 99cv</li>

						<li style={{ fontWeight: "bold" }}>Protector de cárter</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Espejos retrovisores elétricos</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Llantas</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Aleación diamantadas de 15" (Neumáticos ATR)</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Sensor de estacionamiento</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Cierre centralizado</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Alzacristales eléctricos en las 4 puertas</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Volante regulable en altura</li>
						<li>SI</li>
					</div>
				}
				{/* {option == 'freedom-simples' && 
					<div style={{ overflow: "scroll", maxHeight: "32vh" }}>
						<li style={{ fontWeight: "bold" }}>Quantidade de lugares e portas</li>
						<li>2 portas e 2 lugares</li>

						<li style={{ fontWeight: "bold" }}>Air bag lateral</li>
						<li>NÃO</li>
						
						<li style={{ fontWeight: "bold" }}>Alarme</li>
						<li>SIM</li>
						
						<li style={{ fontWeight: "bold" }}>Ar-condicionado</li>
						<li>SIM</li>
						
						<li style={{ fontWeight: "bold" }}>Assistente de partida em rampa - Hill Holder</li>
						<li>SIM</li>
						
						<li style={{ fontWeight: "bold" }}>Bancos em couro/tecido</li>
						<li>NÃO</li>
						
						<li style={{ fontWeight: "bold" }}>Barras longitudinais no teto</li>
						<li>NÃO</li>
						
						<li style={{ fontWeight: "bold" }}>Câmera de ré</li>
						<li>NÃO</li>
						
						<li style={{ fontWeight: "bold" }}>Capota marítima</li>
						<li>SIM</li>
						
						<li style={{ fontWeight: "bold" }}>Central multimídia com tela touchscreen de 7"</li>
						<li>NÃO</li>
						
						<li style={{ fontWeight: "bold" }}>Comandos de áudio no volante</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Controle eletrônico de estabilidade</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Detalhes externos na cor do veículo</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Direção</li>
						<li>Alarma y cierre centralizado</li>

						<li style={{ fontWeight: "bold" }}>E-Locker - Controle de Tração Avançado (TC+)  </li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Faróis em LED</li>
						<li>NÃO</li>

						<li style={{ fontWeight: "bold" }}>Farol de neblina</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Grade de proteção no vidro traseiro</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Iluminação da caçamba</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Isofix</li>
						<li>NÃO</li>

						<li style={{ fontWeight: "bold" }}>Motor</li>
						<li>Motor Firefly FLEX</li>

						<li style={{ fontWeight: "bold" }}>Protetor de cárter</li>
						<li>NÃO</li>

						<li style={{ fontWeight: "bold" }}>Retrovisores elétricos</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Rodas</li>
						<li>Rodas em liga leve 15"</li>

						<li style={{ fontWeight: "bold" }}>Santoantonio</li>
						<li>NÃO</li>

						<li style={{ fontWeight: "bold" }}>Sensor de estacionamento</li>
						<li>NÃO</li>

						<li style={{ fontWeight: "bold" }}>Travas elétricas</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Vidros dianteiros elétricos</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Vidros traseiros elétricos</li>
						<li>NÃO</li>

						<li style={{ fontWeight: "bold" }}>Volante com regulagem de altura</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>2a. USB</li>
						<li>NÃO</li>
					</div>
				} */}
				{option == 'freedom-dupla' && 
					<div style={{ overflow: "scroll", maxHeight: "32vh" }}>
						<li style={{ fontWeight: "bold" }}>Cantidad de lugares y puertas</li>
						<li>5 plazas y 4 puertas</li>

						<li style={{ fontWeight: "bold" }}>Airbag lateral</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Alarma</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Aire-acondicionado</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Asistente al arranque en pendiente</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Tapizado</li>
						<li>Tela</li>
						
						<li style={{ fontWeight: "bold" }}>Cámara de reversa</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Capota marítima</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Central multimedia de 7’’</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Comandos de audio al volante</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Control de estabilidad</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Asistencia a la dirección</li>
						<li>Hidráulica</li>

						<li style={{ fontWeight: "bold" }}>E-Locker - Control de tracción avanzado (TC+)</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Luces LED</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Antinieblas delanteros</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Protección luneta trasera</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Iluminación en la caja de carga</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Anclajes Isofix</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Motor</li>
						<li>Fire 1.4 de 85cv</li>

						<li style={{ fontWeight: "bold" }}>Protector de cárter</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Espejos retrovisores elétricos</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Protetor de cárter</li>
						<li>SIM</li>

						<li style={{ fontWeight: "bold" }}>Llantas</li>
						<li>Aleación de 15"</li>

						<li style={{ fontWeight: "bold" }}>Sensor de estacionamiento</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Cierre centralizado</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Alzacristales eléctricos en las 4 puertas</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Volante regulable en altura</li>
						<li>SI</li>

					</div>
				}
				{option == 'endurance-simples' && 
					<div style={{ overflow: "scroll", maxHeight: "32vh" }}>
						<li style={{ fontWeight: "bold" }}>Cantidad de lugares y puertas</li>
						<li>5 plazas y 4 puertas</li>

						<li style={{ fontWeight: "bold" }}>Airbag lateral</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Alarma</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Aire-acondicionado</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Asistente al arranque en pendiente</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Tapizado</li>
						<li>Tela</li>
						
						<li style={{ fontWeight: "bold" }}>Cámara de reversa</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Capota marítima</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Central multimedia de 7’’</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Comandos de audio al volante</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Control de estabilidad</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Asistencia a la dirección</li>
						<li>Hidráulica</li>

						<li style={{ fontWeight: "bold" }}>E-Locker - Control de tracción avanzado (TC+)</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Luces LED</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Antinieblas delanteros</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Protección luneta trasera</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Iluminación en la caja de carga</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Anclajes Isofix</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Motor</li>
						<li>Fire 1.4 de 85cv</li>

						<li style={{ fontWeight: "bold" }}>Protector de cárter</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Espejos retrovisores elétricos</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Llantas</li>
						<li>Chapa con embellecedor de 15"</li>

						<li style={{ fontWeight: "bold" }}>Sensor de estacionamiento</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Cierre centralizado</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Alzacristales eléctricos en las 4 puertas</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Volante regulable en altura</li>
						<li>SI</li>
					</div>
				}
				{option == 'endurance-dupla' && 
					<div style={{ overflow: "scroll", maxHeight: "32vh" }}>
						<li style={{ fontWeight: "bold" }}>Cantidad de lugares y puertas</li>
						<li>5 plazas y 4 puertas</li>

						<li style={{ fontWeight: "bold" }}>Airbag lateral</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Alarma</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Aire-acondicionado</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Asistente al arranque en pendiente</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Tapizado</li>
						<li>Tela</li>
						
						<li style={{ fontWeight: "bold" }}>Cámara de reversa</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Capota marítima</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Central multimedia de 7’’</li>
						<li>NO</li>
						
						<li style={{ fontWeight: "bold" }}>Comandos de audio al volante</li>
						<li>SI</li>
						
						<li style={{ fontWeight: "bold" }}>Control de estabilidad</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Asistencia a la dirección</li>
						<li>Hidráulica</li>

						<li style={{ fontWeight: "bold" }}>E-Locker - Control de tracción avanzado (TC+)</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Luces LED</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Antinieblas delanteros</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Protección luneta trasera</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Iluminación en la caja de carga</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Anclajes Isofix</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Motor</li>
						<li>Fire 1.4 de 85cv</li>

						<li style={{ fontWeight: "bold" }}>Protector de cárter</li>
						<li>SI</li>

						<li style={{ fontWeight: "bold" }}>Espejos retrovisores elétricos</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Llantas</li>
						<li>Chapa con embellecedor de 15"</li>

						<li style={{ fontWeight: "bold" }}>Sensor de estacionamiento</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Cierre centralizado</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Alzacristales eléctricos en las 4 puertas</li>
						<li>NO</li>

						<li style={{ fontWeight: "bold" }}>Volante regulable en altura</li>
						<li>SI</li>
					</div>
				}
			</ul>
		)
	}

	return (
		<div className={cls(classes.root, className)}>
			 <div className={cls(classes.header)}>
				 <h2 className={cls(classes.title)}>Compare las versiones de la nueva Fiat Strada</h2>
			 </div>
			 <div className={cls(classes.versions)}>
			     <div className={cls(classes.carro1avatar)}>
					 <label for="cars">
						 {optionTwo == 'volcano' && <img  className={cls(classes.avatar)} src="/assets/images/desktop/360/nav/volcano.png" />}
						 {optionTwo == 'freedom-simples' && <img  className={cls(classes.avatar)}  src="/assets/images/desktop/360/nav/freedom-simples.png" />}
						 {optionTwo == 'freedom-dupla' && <img  className={cls(classes.avatar)}  src="/assets/images/desktop/360/nav/freedom-dupla.png" />}
						 {optionTwo == 'endurance-simples' && <img  className={cls(classes.avatar)}  src="/assets/images/desktop/360/nav/endurance-simples.png" />}
						 {optionTwo == 'endurance-dupla' && <img  className={cls(classes.avatar)}  src="/assets/images/desktop/360/nav/endurance-dupla.png" />}
					 </label>
					 <select name="cars" id="cars" onChange={() => setOptionTwo(event.target.value)} className={cls(classes.select)}>
						 <option value="volcano" selected>Volcano </option>
						 {/* <option value="freedom-simples">Freedom Cabina Plus</option> */}
						 <option value="freedom-dupla">Freedom Cabina Doble</option>
						 <option value="endurance-simples">Endurance Cabina Plus</option>
						 <option value="endurance-dupla">Endurance Cabina Doble</option>
					 </select>
			     </div>

				 <div  className={cls(classes.carro2avatar)}>
					 <label for="cars">
						 <label for="cars">
						 {optionOne == 'volcano' && <img  className={cls(classes.avatar)}  src="/assets/images/desktop/360/nav/volcano.png" />}
						 {optionOne == 'freedom-simples' && <img  className={cls(classes.avatar)}  src="/assets/images/desktop/360/nav/freedom-simples.png" />}
						 {optionOne == 'freedom-dupla' && <img  className={cls(classes.avatar)}  src="/assets/images/desktop/360/nav/freedom-dupla.png" />}
						 {optionOne == 'endurance-simples' && <img  className={cls(classes.avatar)}  src="/assets/images/desktop/360/nav/endurance-simples.png" />}
						 {optionOne == 'endurance-dupla' && <img  className={cls(classes.avatar)}  src="/assets/images/desktop/360/nav/endurance-dupla.png" />}
						 </label>
					 </label>
					 <select name="cars-2" id="cars-2" onChange={() => setOptionOne(event.target.value)} className={cls(classes.select)}>
						 <option value="volcano">Volcano </option>
						 {/* <option value="freedom-simples" selected>Freedom Cabina Plus</option> */}
						 <option value="freedom-dupla">Freedom Cabina Doble</option>
						 <option value="endurance-simples">Endurance Cabina Plus</option>
						 <option value="endurance-dupla">Endurance Cabina Doble</option>
					 </select>
				 </div>
			 </div>
			 <div className={cls(classes.info)}>
				 <p className={cls(classes.headerInfo)}>Resumen</p>
				 <div className={cls(classes.carro1)}>
				 	{renderResume(optionTwo)}
					 {/* <ul>
						 <li>Cabina Doble e Dupla</li>
						 <li>Caçamba com 1123L e 683L</li>
						 <li>770kg e 650kg de carga </li>
						 <li>Até 210mm de altura do solo</li>
						 <li>Motor Fire 88cv</li>
						 <li>2 e 4 portas</li>
						 <li>Direção hidráulica</li>
					 </ul> */}
					 <div className={cls(classes.button)}>
					 	<DataLayer onEvent={'VersionsPage_CompreOSeuV1'} args={[]}>
							<Link className={classes.btn} href={'https://fiat.com.ar/contactenos?type=191'}>
								ELEGÍ LA TUYA --
							</Link>
						</DataLayer>
					 </div>
				 </div>

				 <div className={cls(classes.carro2)}>
				 	{renderResume(optionOne)}
					 {/* <ul>
						 <li>Cabina Simple y Doble</li>
						 <li>Caçamba com 123L e 683L</li>
						 <li>770kg e 650kg de carga </li>
						 <li>Até 210mm de altura do solo</li>
						 <li>Motor Fire 88cv</li>
						 <li>2 e 4 portas</li>
						 <li>Direção hidráulica</li>
					 </ul> */}
					 <div className={cls(classes.button)}>
						<DataLayer onEvent={'VersionsPage_CompreOSeuV2'} args={[]}>
							<Link className={classes.btn} to={'https://fiat.com.ar/contactenos?type=191'}>
							    ELEGÍ LA TUYA --
							</Link>
						</DataLayer>
					 </div>
				 </div>
			 </div>
		 </div>
	);
};

Comparativo.displayName = 'Comparativo';
Comparativo.propTypes = propTypes;
Comparativo.defaultProps = defaultProps;
export default Comparativo;
